/**
 * 尺码转换配置
 * 支持 US-M, US-W, UK, EU, CM, IN 之间的转换
 */

(function() {
  'use strict';

  /**
   * 标准尺码转换表 - 天猫标准欧码格式
   * 基于 US-M 作为主键
   * EU 使用 Unicode 分数格式: 39 ⅔, 40 ⅓, 41 ⅔, 42 ⅓ 等
   */
  const SIZE_CONVERSION_TABLE = [
    { 'US-M': '4.5',  'US-W': '5.5',  'UK': '3.5',  'EU': '36 ⅓',   'CM': '22.0', 'IN': '8.6' },
    { 'US-M': '5',    'US-W': '6',    'UK': '4',    'EU': '37',     'CM': '22.5', 'IN': '8.8' },
    { 'US-M': '5.5',  'US-W': '6.5',  'UK': '4.5',  'EU': '37 ⅔',   'CM': '23.0', 'IN': '9.0' },
    { 'US-M': '6',    'US-W': '7',    'UK': '5',    'EU': '38 ⅓',   'CM': '23.5', 'IN': '9.2' },
    { 'US-M': '6.5',  'US-W': '7.5',  'UK': '5.5',  'EU': '39',     'CM': '24.0', 'IN': '9.4' },
    { 'US-M': '7',    'US-W': '8',    'UK': '6',    'EU': '39 ⅔',   'CM': '24.5', 'IN': '9.6' },
    { 'US-M': '7.5',  'US-W': '8.5',  'UK': '6.5',  'EU': '40 ⅓',   'CM': '25.0', 'IN': '9.8' },
    { 'US-M': '8',    'US-W': '9',    'UK': '7',    'EU': '41',     'CM': '25.5', 'IN': '10.0' },
    { 'US-M': '8.5',  'US-W': '9.5',  'UK': '7.5',  'EU': '41 ⅔',   'CM': '26.0', 'IN': '10.2' },
    { 'US-M': '9',    'US-W': '10',   'UK': '8',    'EU': '42 ⅓',   'CM': '26.5', 'IN': '10.4' },
    { 'US-M': '9.5',  'US-W': '10.5', 'UK': '8.5',  'EU': '43',     'CM': '27.0', 'IN': '10.6' },
    { 'US-M': '10',   'US-W': '11',   'UK': '9',    'EU': '43 ⅔',   'CM': '27.5', 'IN': '10.8' },
    { 'US-M': '10.5', 'US-W': '11.5', 'UK': '9.5',  'EU': '44 ⅓',   'CM': '28.0', 'IN': '11.0' },
    { 'US-M': '11',   'US-W': '12',   'UK': '10',   'EU': '45',     'CM': '28.5', 'IN': '11.2' },
    { 'US-M': '11.5', 'US-W': '12.5', 'UK': '10.5', 'EU': '45 ⅔',   'CM': '29.0', 'IN': '11.4' },
    { 'US-M': '12',   'US-W': '13',   'UK': '11',   'EU': '46 ⅓',   'CM': '29.5', 'IN': '11.6' },
    { 'US-M': '12.5', 'US-W': '13.5', 'UK': '11.5', 'EU': '47',     'CM': '30.0', 'IN': '11.8' },
    { 'US-M': '13',   'US-W': '14',   'UK': '12',   'EU': '47 ⅔',   'CM': '30.5', 'IN': '12.0' },
    { 'US-M': '13.5', 'US-W': '14.5', 'UK': '12.5', 'EU': '48 ⅓',   'CM': '31.0', 'IN': '12.2' },
    { 'US-M': '14',   'US-W': '15',   'UK': '13',   'EU': '49',     'CM': '31.5', 'IN': '12.4' },
    { 'US-M': '14.5', 'US-W': '15.5', 'UK': '13.5', 'EU': '49 ⅔',   'CM': '32.0', 'IN': '12.6' },
    { 'US-M': '15',   'US-W': '16',   'UK': '14',   'EU': '50 ⅓',   'CM': '32.5', 'IN': '12.8' }
  ];

  /**
   * 尺码系统配置
   */
  const SIZE_SYSTEMS = {
    'US-M': { label: 'US Men', shortLabel: 'US-M' },
    'US-W': { label: 'US Women', shortLabel: 'US-W' },
    'UK': { label: 'UK', shortLabel: 'UK' },
    'EU': { label: 'EU', shortLabel: 'EU' },
    'CM': { label: 'CM (厘米)', shortLabel: 'CM' },
    'IN': { label: 'IN (英寸)', shortLabel: 'IN' }
  };

  /**
   * 尺码转换器类
   */
  class SizeConverter {
    constructor() {
      this.conversionTable = SIZE_CONVERSION_TABLE;
      this.systems = SIZE_SYSTEMS;
    }

    /**
     * 从产品 option 值解析尺码
     * 例如: "M 6.5 / W 7.5" -> { 'US-M': '6.5', 'US-W': '7.5' } (鞋类)
     * 例如: "S" -> { 'APPAREL': 'S' } (服装)
     * 例如: "SIZE US M 6.5 / W 7.5" -> { 'US-M': '6.5', 'US-W': '7.5' }
     */
    parseOptionValue(optionValue) {
      if (!optionValue) return null;

      // 清理前缀 "SIZE US" 等
      let cleanValue = optionValue.replace(/^SIZE\s+US\s+/i, '').trim();

      const result = {};

      // 移除括号内的内容,避免误识别袜子等产品的辅助尺码信息
      // 例如: "L (M 6.5-10)" -> "L"
      const valueWithoutParentheses = cleanValue.replace(/\s*\([^)]*\)/g, '').trim();

      // 匹配 "M 6.5 / W 7.5" 格式 (鞋类)
      // 使用移除括号后的值进行匹配
      const usMenMatch = valueWithoutParentheses.match(/M\s+([\d.]+)/i);
      const usWomenMatch = valueWithoutParentheses.match(/W\s+([\d.]+)/i);

      if (usMenMatch) {
        result['US-M'] = usMenMatch[1];
      }
      if (usWomenMatch) {
        result['US-W'] = usWomenMatch[1];
      }

      // 如果没有匹配到鞋码,检查是否是服装尺码 (S, M, L, XL, XXL, XXXL 等)
      if (Object.keys(result).length === 0) {
        const apparelSizeMatch = valueWithoutParentheses.match(/^(XXX?L|XX?L|XL|L|M|S|XS)$/i);
        if (apparelSizeMatch) {
          result['APPAREL'] = apparelSizeMatch[1].toUpperCase();
        } else {
          // 其他格式,直接返回原值
          result['OTHER'] = cleanValue;
        }
      }

      return Object.keys(result).length > 0 ? result : null;
    }

    /**
     * 检测产品类型
     * @param {array} variants - 产品变体数组
     * @returns {string} 'FOOTWEAR' | 'APPAREL' | 'OTHER'
     */
    detectProductType(variants) {
      if (!variants || variants.length === 0) return 'OTHER';

      const firstVariant = variants[0];
      const optionValue = firstVariant.option1 || firstVariant.title;
      const parsed = this.parseOptionValue(optionValue);

      if (!parsed) return 'OTHER';

      if (parsed['US-M'] || parsed['US-W']) {
        return 'FOOTWEAR'; // 鞋类
      } else if (parsed['APPAREL']) {
        return 'APPAREL'; // 服装
      }

      return 'OTHER';
    }

    /**
     * 转换尺码到所有系统
     * @param {string} fromSystem - 源尺码系统 (US-M, US-W, UK, EU, CM, IN)
     * @param {string} size - 尺码值
     * @returns {object} 包含所有系统尺码的对象
     */
    convertSize(fromSystem, size) {
      // 标准化尺码值(去除空格,统一格式)
      const normalizedSize = String(size).trim();

      // 在转换表中查找匹配的行
      const row = this.conversionTable.find(r =>
        String(r[fromSystem]).trim() === normalizedSize
      );

      if (!row) {
        console.warn(`尺码转换: 找不到 ${fromSystem} ${size} 的转换数据`);
        return null;
      }

      return { ...row };
    }

    /**
     * 从产品 option 值获取所有系统的尺码
     * @param {string} optionValue - 产品选项值 (例如: "M 6.5 / W 7.5")
     * @returns {object} 所有系统的尺码
     */
    convertFromOptionValue(optionValue) {
      const parsed = this.parseOptionValue(optionValue);
      if (!parsed) return null;

      // 优先使用 US-M,其次 US-W
      const fromSystem = parsed['US-M'] ? 'US-M' : 'US-W';
      const size = parsed[fromSystem];

      return this.convertSize(fromSystem, size);
    }

    /**
     * 获取指定系统的显示标签
     * @param {string} size - 尺码值
     * @param {string} system - 尺码系统
     * @returns {string} 格式化的显示文本
     */
    formatSizeLabel(size, system) {
      const systemConfig = this.systems[system];
      if (!systemConfig) return size;

      // 对于 CM 和 IN,添加单位
      if (system === 'CM') {
        return `${size} cm`;
      } else if (system === 'IN') {
        return `${size}"`;
      }

      // US-M, US-W, UK, EU 都只显示数字
      return size;
    }

    /**
     * 获取所有可用的尺码系统
     * @returns {array} 系统列表
     */
    getAvailableSystems() {
      return Object.keys(this.systems).map(key => ({
        key,
        ...this.systems[key]
      }));
    }

    /**
     * 批量转换产品的所有变体
     * @param {array} variants - 产品变体数组
     * @returns {array} 包含转换后尺码的变体数组
     */
    convertProductVariants(variants) {
      return variants.map(variant => {
        // 假设尺码在 option1 中
        const optionValue = variant.option1 || variant.title;
        const convertedSizes = this.convertFromOptionValue(optionValue);

        return {
          ...variant,
          convertedSizes: convertedSizes || {}
        };
      });
    }

    /**
     * 根据系统和尺码查找变体
     * @param {array} variants - 变体数组(已包含 convertedSizes)
     * @param {string} system - 目标尺码系统
     * @param {string} size - 目标尺码
     * @returns {object|null} 匹配的变体
     */
    findVariantBySize(variants, system, size) {
      return variants.find(v =>
        v.convertedSizes &&
        String(v.convertedSizes[system]).trim() === String(size).trim()
      ) || null;
    }
  }

  // 创建全局实例
  window.SizeConverter = SizeConverter;
  window.sizeConverter = new SizeConverter();

  // 导出转换表和系统配置(便于其他模块使用)
  window.SIZE_CONVERSION_TABLE = SIZE_CONVERSION_TABLE;
  window.SIZE_SYSTEMS = SIZE_SYSTEMS;

})();
